import { PostErrorResetPasswordResponse, PostErrorResponse, PostRegisterErrorResponse } from "services/idm";

type ApiError = PostErrorResponse | PostErrorResetPasswordResponse | PostRegisterErrorResponse;

export function apiErrorHandler(error: ApiError | any, lang: string = 'en') {
    if (error && error.status && error.status === 500) {
        window.location.replace(`/${lang}/error/500`);
    }
}